import IdCards from './IdCards'
export default IdCards
